import { TablePagination } from "@material-ui/core";
import MaterialTable from "material-table";
import moment from "moment";
import { useSelector } from "react-redux";
import { tableIcons } from "../../tableIcons";
import { useCurrency } from "../../provider/courtryProvider";
import CustomTable from "../table";
import { Button } from "antd";
import { useAccess } from "../../provider/AccessProvider";

const Expenses = ({
  loading = false,
  expensesList = [],
  setOpen = () => {},
  counterId = "",
}) => {
  const expenseTypeList = useSelector(
    (state) => state.shopDetails.expensesType
  );
  const access = useAccess(["counterHistory", "counterExpenses"]);
  const currencyFormatter = useCurrency();
  const columns = [
    {
      title: "Date",
      sorter: (a, b) =>
        moment(b.expenseDate, "YYYY-MM-DD").format("X") -
        moment(a.expenseDate, "YYYY-MM-DD").format("X"),
      render: (rowData) => {
        return (
          <span>
            {moment(rowData.expenseDate, "YYYY-MM-DD").format("DD-MM-YYYY")}
          </span>
        );
      },
      cellStyle: {
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Expense Amount",
      cellStyle: {
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "center",
      },
      sorter: (a, b) => parseInt(b.expenseAmount) - parseInt(a.expenseAmount),
      render: (rowData) => {
        return <span>{currencyFormatter(rowData.expenseAmount)}</span>;
      },
    },
    {
      title: "Expense Type",
      cellStyle: {
        textAlign: "center",
        textTransform: "capitalize",
      },
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) => {
        const type = expenseTypeList.find(
          (i) => i.expensesTypeId === rowData.expenseType
        );
        console.log("expenseTypeList", expenseTypeList);

        return <span>{type.expensesTypeName}</span>;
      },
    },
    {
      title: "Payment Method",
      render: (rowData) => {
        return <span>{rowData.paymentMethod}</span>;
      },

      cellStyle: {
        textAlign: "center",
        textTransform: "capitalize",
      },
      headerStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Notes",
      render: (rowData) => {
        return <span>{rowData.notes}</span>;
      },

      cellStyle: {
        textAlign: "center",
        textTransform: "capitalize",
      },
      headerStyle: {
        textAlign: "center",
      },
    },
  ];
  const exportHead = [
    "Date",
    "Expense Amount",
    "Type",
    "Payment Method",
    "Notes",
  ];
  const exportValue = [
    "expenseDate",
    "expenseAmount",
    "expenseTypeName",
    "paymentMethod",
    "notes",
  ];
  return (
    <>
      <CustomTable
        columns={columns}
        data={expensesList}
        title={"Expenses"}
        emptyContainerStyle={{
          minHeight: "calc(100vh - 300px)",
        }}
        excelExport={true}
        exportHead={exportHead}
        exportValue={exportValue}
        csvAccessKey="counterCSVExport"
        extraAction={
          <Button
            type="primary"
            onClick={() => {
              if (!access.counterExpenses()) {
                return;
              }
              if (!counterId) {
                return alert(
                  "Please open the counter before creating Expenses"
                );
              }
              setOpen();
            }}
          >
            Create Expense
          </Button>
        }
      />
      {/* <MaterialTable
        style={{ textAlign: "center", boxShadow: "none" }}
        isLoading={loading}
        columns={[
          {
            title: "Date",
            render: (rowData) => {
              return (
                <span>
                  {moment(rowData.expenseDate, "YYYY-MM-DD").format(
                    "DD-MM-YYYY"
                  )}
                </span>
              );
            },
            cellStyle: {
              textAlign: "center",
            },
            headerStyle: {
              textAlign: "center",
            },
          },
          {
            title: "Expense Amount",
            cellStyle: {
              textAlign: "center",
            },
            headerStyle: {
              textAlign: "center",
            },
            render: (rowData) => {
              return <span>{currencyFormatter(rowData.expenseAmount)}</span>;
            },
          },
          {
            title: "Expense Type",
            cellStyle: {
              textAlign: "center",
              textTransform: "capitalize",
            },
            headerStyle: {
              textAlign: "center",
            },
            render: (rowData) => {
              const type = expenseTypeList.find(
                (i) => i.expensesTypeId === rowData.expenseType
              );
              console.log("expenseTypeList", expenseTypeList);

              return <span>{type.expensesTypeName}</span>;
            },
          },
          {
            title: "Payment Method",
            render: (rowData) => {
              return <span>{rowData.paymentMethod}</span>;
            },

            cellStyle: {
              textAlign: "center",
              textTransform: "capitalize",
            },
            headerStyle: {
              textAlign: "center",
            },
          },
        ]}
        icons={tableIcons}
        data={expensesList}
        title={
          <>
            <Button
              variant="outline-danger"
              onClick={() => {
                if (!counterId) {
                  return alert(
                    "Please open the counter before creating Expenses"
                  );
                }
                setOpen(true);
              }}
            >
              Add Expenses
            </Button>
          </>
        }
        components={{
          Pagination: PatchedPagination,
        }}
        options={{
          search: true,
          exportButton: {
            csv: true,
          },
          exportCsv: (_columns, renderData) => {
            const fields = _columns.map((i) => i.title);
            const opts = { fields };
            const parser = new Parser(opts);
            const rows = expensesList.map((i) => {
              const type = expenseTypeList.find(
                (item) => item.expensesTypeId === i.expenseType
              );
              return {
                Date: i.expenseDate,
                "Expense Amount": i.expenseAmount,
                "Expense Type": type.expensesTypeName,
                "Payment Method": i.paymentMethod,
              };
            });
            console.log("rows", rows);
            const csv = parser.parse(rows);
            console.log("csv", csv, rows);
            var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            var link = document.createElement("a");

            var url = URL.createObjectURL(blob);

            link.setAttribute("href", url);
            link.setAttribute("download", "Expenses.csv");
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          },
          exportFileName: "Expense",
          columnsButton: true,
          pageSize: 10,
        }}
      /> */}
    </>
  );
};

export default Expenses;
